import ChevronDownIcon from "@uui/ChevronDown";
import ChevronUpIcon from "@uui/ChevronUp";

import { Divider } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Button from "@rui/Button";
import { Row } from "@rui/Stack";

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  "&:hover": {
    backgroundColor: theme.palette.shades.ghost[500],
  },
}));

const SeeAllButton = ({
  expandLabel,
  expanded,
  onCollapse,
  onExpand,
}: {
  expandLabel: string;
  expanded: boolean;
  onCollapse: () => void;
  onExpand: () => void;
}) => {
  const onClick = expanded ? onCollapse : onExpand;
  const Icon = expanded ? ChevronUpIcon : ChevronDownIcon;

  return (
    <Row spacing={1} sx={{ width: "100%" }}>
      <Row flex={1} variant="center">
        <Divider orientation="horizontal" sx={{ width: "100%" }} />
      </Row>
      <StyledButton
        onClick={onClick}
        variant="text"
        endIcon={<Icon sx={{ width: "16px" }} />}
      >
        {expanded ? "Only show filtered recommendations" : expandLabel}
      </StyledButton>
      <Row flex={1} variant="center">
        <Divider orientation="horizontal" sx={{ width: "100%" }} />
      </Row>
    </Row>
  );
};

export default SeeAllButton;
